export const MAX_TIMELINE_DAYS = 3660;
export const isISODate = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};
export const addDays = (value, days) => {
  const parsed = new Date(`${value}T00:00:00Z`);
  parsed.setUTCDate(parsed.getUTCDate() + days);
  return parsed.toISOString().slice(0, 10);
};
export const daysBetween = (left, right) => Math.round((Date.parse(left) - Date.parse(right)) / 86400000);
export const timelineRange = (board, fallbackDays) => {
  const legacyDays = Number.isInteger(board.dayCount) && board.dayCount > 0 ? board.dayCount : fallbackDays;
  const requestedEnd = isISODate(board.endDate) ? board.endDate : addDays(board.startDate, Math.min(MAX_TIMELINE_DAYS, legacyDays) - 1);
  const dayCount = Math.max(1, Math.min(MAX_TIMELINE_DAYS, daysBetween(requestedEnd, board.startDate) + 1));
  return { endDate: addDays(board.startDate, dayCount - 1), dayCount };
};
